import {combineReducers} from 'redux';
import cardReader from './cardReader';
import omaviihde from './omaviihde';
import rex from './rex';
import user from './user';
import userDetails from './userDetails';

const rootReducer = combineReducers({
  cardReader,
  omaviihde,
  rex,
  user,
  userDetails
});

export default rootReducer;



// WEBPACK FOOTER //
// ./web/js/stores/reducers/index.js